import { createClientLogger } from "@azure/logger";
export var logger = createClientLogger("core-http");
//# sourceMappingURL=log.js.map